import imgAerra101 from "./img-aerra10 (1).webp";
import imgAerra102 from "./img-aerra10 (2).webp";
import imgAerra103 from "./img-aerra10 (3).webp";
import imgAerra104 from "./img-aerra10 (4).webp";

const imgAerra10 = [imgAerra101, imgAerra102, imgAerra103, imgAerra104];

export default imgAerra10;
